import React from 'react';
import {observer} from "mobx-react";
import {AppState} from "../AppState";
import Slider from "./Slider";

@observer
export default class Home extends React.Component<{ appState: AppState }, {}> {
    render() {
        const {appState} = this.props;
        return (
            <div className="Home">
                <Slider
                    appState={appState}
                    list={appState.banner}
                />
            </div>
        );
    }
}
